import { render, staticRenderFns } from "./Informaition.vue?vue&type=template&id=fc3db8a8&scoped=true"
import script from "./Informaition.vue?vue&type=script&lang=js"
export * from "./Informaition.vue?vue&type=script&lang=js"
import style0 from "./Informaition.vue?vue&type=style&index=0&id=fc3db8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3db8a8",
  null
  
)

export default component.exports